var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: (_vm.isEdit ? "编辑" : "新增") + "商品信息",
        visible: _vm.dialogVisible,
        width: "900px",
        top: "5%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _vm.dialogVisible
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "rule_form",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "150px",
                  },
                },
                [
                  _c("div", { staticClass: "section_title" }, [
                    _vm._v("商品获取"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道：", prop: "platformCode" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isEdit },
                          on: { change: _vm.onPlatformChange },
                          model: {
                            value: _vm.ruleForm.platformCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "platformCode", $$v)
                            },
                            expression: "ruleForm.platformCode",
                          },
                        },
                        _vm._l(_vm.platformOption, function (item) {
                          return _c(
                            "el-radio",
                            { key: item.code, attrs: { label: item.code } },
                            [
                              _c("img", {
                                staticClass: "platform_icon",
                                attrs: { src: item.icon, alt: "" },
                              }),
                              _vm._v(_vm._s(item.name) + "\n          "),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属活动：", prop: "activityId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.isEdit,
                            filterable: "",
                            clearable: "",
                            placeholder: "请输入",
                          },
                          model: {
                            value: _vm.ruleForm.activityId,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "activityId", $$v)
                            },
                            expression: "ruleForm.activityId",
                          },
                        },
                        _vm._l(_vm.activityOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form_tip" }, [
                        _vm._v("支持下拉选择和输入框搜索"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "商品口令/链接：", prop: "goodsCommand" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "command_box" },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isEdit,
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.ruleForm.goodsCommand,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "goodsCommand", $$v)
                              },
                              expression: "ruleForm.goodsCommand",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.isEdit
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "ml10",
                                  attrs: { type: "primary", plain: "" },
                                  on: { click: _vm.onSearchGoods },
                                },
                                [_vm._v("搜索")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form_tip" }, [
                        _vm._v(
                          "注：确认商品，点击保存后，商品ID可能会替换为平台专属商品ID，ID样式可能会发生变化"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ref_box" }, [
                    _c("div", { staticClass: "ref_title" }, [
                      _vm._v("商品参考信息（自动获取，不可编辑）"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ref_content" },
                      [
                        _c(
                          "div",
                          { staticClass: "ref_img_box" },
                          [
                            _vm.ruleForm.goodsPic
                              ? _c("el-image", {
                                  staticClass: "ref_img",
                                  attrs: {
                                    src: _vm.ruleForm.goodsPic,
                                    "preview-src-list": [_vm.ruleForm.goodsPic],
                                    fit: "scale-down",
                                  },
                                })
                              : _c("div", { staticClass: "ref_placeholder" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-picture-outline ref_placeholder_icon",
                                  }),
                                  _vm._v(" "),
                                  _c("div", [_vm._v("等待搜索加载")]),
                                ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "ref_info" }, [
                          _c("div", { staticClass: "ref_row" }, [
                            _vm._v("商品标题："),
                            _c("span", [
                              _vm._v(_vm._s(_vm.ruleForm.title || "--")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ref_row" }, [
                            _vm._v("商品ID："),
                            _c("span", [
                              _vm._v(_vm._s(_vm.ruleForm.goodsId || "--")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ref_row" }, [
                            _vm._v("原价："),
                            _c("span", [
                              _vm._v(_vm._s(_vm.ruleForm.originPrice || "--")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ref_row" }, [
                            _vm._v("券后价："),
                            _c("span", [
                              _vm._v(_vm._s(_vm.ruleForm.couponPrice || "--")),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              disabled: !_vm.ruleForm.goodsId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.copy(_vm.ruleForm.goodsId)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section_title mt20" }, [
                    _vm._v("活动与库存配置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品副标题：", prop: "subTitle" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.subTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "subTitle", $$v)
                          },
                          expression: "ruleForm.subTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上架数量：", prop: "stockTotal" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.isEdit, placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.stockTotal,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "stockTotal", _vm._n($$v))
                          },
                          expression: "ruleForm.stockTotal",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form_tip" }, [
                        _vm._v(
                          "首次设置后不可编辑，追加请在商品列表点击「补充库存」操作，追加后总上架数量将同步更新"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "每人限购数量：", prop: "perLimit" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.ruleForm.perLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "perLimit", _vm._n($$v))
                            },
                            expression: "ruleForm.perLimit",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("单")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "补贴方式：", prop: "subsidyType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.subsidyType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "subsidyType", $$v)
                            },
                            expression: "ruleForm.subsidyType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("固定金额"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("按比例"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.subsidyType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "补贴金额：", prop: "subsidyAmt" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.ruleForm.subsidyAmt,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "subsidyAmt",
                                  _vm._n($$v)
                                )
                              },
                              expression: "ruleForm.subsidyAmt",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form_tip" }, [
                            _vm._v(
                              "设置的补贴金额，需 ≤ 商品券后价减去基础返佣(即分享赚)的实付金额！"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        {
                          attrs: { label: "补贴百分比：", prop: "subsidyRate" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.ruleForm.subsidyRate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "subsidyRate",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "ruleForm.subsidyRate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form_tip" }, [
                            _vm._v(
                              "\n          按商品券后价的百分比计算补贴金额，保存时以平台实时券后价换算并落库（百分比不得超过100%）\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.subsidyAmtPreview !== null
                            ? _c("div", { staticClass: "form_tip" }, [
                                _vm._v(
                                  "\n          按当前券后价预估补贴金额：￥" +
                                    _vm._s(_vm.subsidyAmtPreview) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序：", prop: "sortNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.ruleForm.sortNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "sortNo", _vm._n($$v))
                          },
                          expression: "ruleForm.sortNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上线时间：", prop: "timeArray" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.ruleForm.timeArray,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "timeArray", $$v)
                          },
                          expression: "ruleForm.timeArray",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form_tip" }, [
                        _vm._v("注：上线时间须在所属活动时间窗内"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品状态：", prop: "goodsStatus" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.goodsStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "goodsStatus", $$v)
                            },
                            expression: "ruleForm.goodsStatus",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("上架"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("下架"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.saveLoading },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c("el-button", { on: { click: _vm.handleClose } }, [
                            _vm._v("关闭"),
                          ])
                        : _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }